import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  InputAdornment,
  Snackbar,
  TextField,
} from "@mui/material";
import { Save } from "@material-ui/icons";
import firebase from "../firebase";

// Add/edit a location (school/clinic) and the rates charged there.
export default function LocationsForm() {
  const history = useHistory();
  const db = firebase.firestore();

  const params = new URLSearchParams(window.location.search);
  const locationID = params.get("locationID") || "";
  const readOnly =
    params.get("editable") === "false" ||
    window.location.href.includes("sign-in") ||
    window.location.href.includes("signUp");

  const [location, setLocation] = useState("");
  const [sessionSalary, setSessionSalary] = useState("");
  const [groupSalary, setGroupSalary] = useState("");
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (locationID === "") return;
    db.collection("Main")
      .doc(global.config.uid)
      .collection("Locations")
      .doc(locationID)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setLocation(doc.data().Location || "");
          setSessionSalary(doc.data().SessionSalary || "");
          setGroupSalary(doc.data().GroupSalary || "");
        }
      })
      .catch((error) => console.error("Error getting location:", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationID]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const record = {
      Location: location,
      SessionSalary: sessionSalary,
      GroupSalary: groupSalary,
    };
    const locationsRef = db.collection("Main").doc(global.config.uid).collection("Locations");

    if (locationID !== "") {
      locationsRef
        .doc(locationID)
        .set(record, { merge: true })
        .then(() => setToast({ severity: "success", message: "Location updated" }))
        .catch((error) => {
          console.error("Error writing location:", error);
          setToast({ severity: "error", message: "Could not save — try again" });
        });
    } else {
      locationsRef
        .add(record)
        .then((doc) => {
          setToast({ severity: "success", message: "Location created" });
          history.replace("/locations-profile?locationID=" + doc.id);
        })
        .catch((error) => {
          console.error("Error creating location:", error);
          setToast({ severity: "error", message: "Could not save — try again" });
        });
    }
  };

  return (
    <form autoCorrect="off" onSubmit={handleSubmit} id="single-form">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <TextField
          required
          fullWidth
          label="Location Name"
          placeholder="e.g. Lincoln Elementary"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          disabled={readOnly}
        />
        <Box sx={{ display: "flex", gap: 2, flexWrap: { xs: "wrap", sm: "nowrap" } }}>
          <TextField
            required
            fullWidth
            label="Session Rate"
            value={sessionSalary}
            onChange={(e) => setSessionSalary(e.target.value)}
            disabled={readOnly}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
          <TextField
            required
            fullWidth
            label="Group Rate"
            value={groupSalary}
            onChange={(e) => setGroupSalary(e.target.value)}
            disabled={readOnly}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </Box>

        {!readOnly && (
          <Box>
            <Button
              id="save"
              variant="contained"
              color="secondary"
              size="large"
              type="submit"
              startIcon={<Save />}
            >
              {locationID ? "Save Changes" : "Create Location"}
            </Button>
          </Box>
        )}
      </Box>

      <Snackbar
        open={Boolean(toast)}
        autoHideDuration={3000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {toast ? (
          <Alert severity={toast.severity} onClose={() => setToast(null)} sx={{ fontWeight: 600 }}>
            {toast.message}
          </Alert>
        ) : (
          <span />
        )}
      </Snackbar>
    </form>
  );
}
